import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: <svg id="a" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="m20,5.2H4c-1.5,0-2.8,1.3-2.8,2.8v8c0,1.5,1.2,2.8,2.8,2.8h16c1.5,0,2.8-1.2,2.8-2.8v-8c0-1.5-1.3-2.8-2.8-2.8Zm1.2,10.8c0,.7-.6,1.2-1.2,1.2H4c-.7,0-1.2-.6-1.2-1.2v-8c0-.7.6-1.2,1.2-1.2h16c.7,0,1.2.6,1.2,1.2v8Z" stroke-width="0"/><path d="m8,9.8c.4,0,.8-.3.8-.8s-.4-.8-.8-.8h-2c-.4,0-.8.4-.8.8s.4.8.8.8h.2v4.5h-.2c-.4,0-.8.3-.8.8s.3.8.8.8h2c.4,0,.8-.3.8-.8s-.4-.9-.8-.9h-.2v-4.4h.2Z" stroke-width="0"/></svg>
  },
});
